mutation DeleteMatchCampaignCategory($id: ID!) {
  deleteMatchCampaignCategory(input: { id: $id }) {
    success
  }
}
